export default __webpack_public_path__ + "static/media/policy05_2023.ad65ddb5.jpg";